export default class SubscriberCtrl {
    constructor($scope, $filter, $timeout, $rootScope, $state, $stateParams, SideMenu, Subscriber) {
        SideMenu.setActive('subscriber');

        this._scope = $scope;
        this._state = $state;
        this._rootScope = $rootScope;
        this.subscriberRepo = Subscriber;

        this.searching = false;
        this.status = $stateParams.folder ? $stateParams.folder : 'active';
        this.repositoryAttributes = { status: this.status };

        this.statusCount();

        this._scope.$on('subscribersRecount', () => {
            this.statusCount();
        });

        $timeout(() => {
            this.subscriberRepo.getImportProgress().then((progress) => {
                this.importData = progress.data;

                if (progress.data.state == 'Running' || progress.data.state == 'Initializing') {
                    this._rootScope.$emit('progress:start', 'subscriber-import');
                } else if (progress.data.state == 'Finished') {
                    this.exportText = $filter('translate')('SUBSCRIBER:INDEX:IMPORT_FINISHED')
                        .replace(/:date/, this.importData.meta.date)
                        .replace(/:file_name/, this.importData.meta.file_name);
                }
            });
        }, 2000);

        this._rootScope.$on('subscriber:import:completed', () => {
            this.exportText = $filter('translate')('SUBSCRIBER:INDEX:IMPORT_FINISHED')
                .replace(/:date/, this.importData.meta.date)
                .replace(/:file_name/, this.importData.meta.file_name);
        });
    }

    setStatus(status) {
        this._state.go('subscriber.folder', { folder: status });
    };

    toImportReport() {
        this._state.go('subscriber.importReport', { id: this.importData.meta.id });
    };

    statusCount() {
        this.subscriberRepo.statusCount().then((result) => {
            this.counts = result.count;
        });
    };

    stopImport() {
        this.subscriberRepo.stopImport(this.importData.meta.id);
    }
};
